import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import type { IHeaderParams, SortDirection } from 'ag-grid-community';
import CustomTooltip from "./CustomTooltip";

interface SortableIconHeaderProps extends IHeaderParams {
  icon: React.ReactElement;
  tooltipTitle: string;
}

const SortableIconHeader: React.FC<SortableIconHeaderProps> = (props) => {
  const [sort, setSort] = useState<SortDirection>(props.column.getSort() || null);

  useEffect(() => {
    const onSortChanged = () => {
      const currentSort = props.column.getSort();
      setSort(currentSort || null);
    };

    props.api.addEventListener('sortChanged', onSortChanged);
    return () => {
      if (!props.api.isDestroyed()) {
        props.api.removeEventListener('sortChanged', onSortChanged);
      }
    };
  }, [props.api, props.column]);

  const handleClick = () => {
    const nextSort: SortDirection = sort === 'asc' ? 'desc' : sort === 'desc' ? null : 'asc';
    setSort(nextSort);
    props.setSort(nextSort, false);
  };

  return (
    <Box
      onClick={handleClick}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        width: '100%',
        height: '100%',
        gap: 0.5,
      }}
    >
      <CustomTooltip
        title={props.tooltipTitle}
        PopperProps={{
          sx: { '& .MuiTooltip-tooltip': { bgcolor: '#000000', color: '#FFFFFF' } },
        }}
      >
        {props.icon}
      </CustomTooltip>

      {sort === 'asc' && <span className="ag-icon ag-icon-asc" unselectable="on" role="presentation" />}
      {sort === 'desc' && <span className="ag-icon ag-icon-desc" unselectable="on" role="presentation" />}
    </Box>
  );
};

export default SortableIconHeader;